import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import PencilIcon from '@material-ui/icons/Edit'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

import { getSorting, stableSort } from '../../../util/TableUtils'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import EnhancedTableHead from '../../components/TableHead'
import { fetchKnowWay, remove } from '../KnowWayActions'
import Icon from '@mdi/react'
import { mdiNoteEditOutline, mdiDelete } from '@mdi/js'
import BasePopUp from '../../../components/hooks/BasePopUp'
import { StyledTableCellBody } from '../../../components/hooks/BaseTableComponents'
import { Box } from '@material-ui/core'
import colors from '../../../assets/colors'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

function createData(id, name, status, status_text) {
  return { id, name, status, status_text }
}

const headCells = [
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Nome',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
    align: 'center',
  },
]

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  status: {
    textAlign: 'center',
    fontSize: '14p',
    borderRadius: '10px',
    padding: '4px 16px',
    maxWidth: '80px',
    backgroundColor: colors.graylight,
    color: '#000',
  },
  statusAtivo: {
    color: '#FFFF',
    backgroundColor: colors.secondary,
  },
}))

function List(props) {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate, canDelete } = usePermissions()

  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('value')
  const [selected, setSelected] = useState([])

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [knowWayToDelete, setKnowWayToDelete] = useState(null)

  const filters = useQueryParams(location?.search)
  const meta = useSelector(state => state.knowWay.meta)
  const items = useSelector(state => state.knowWay.items)

  const rows = []

  items.map(item => {
    rows.push(createData(item.id, item.name, item.status, item.status_text))
  })

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage + 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleOpenDeleteModal = (id = null) => {
    if (id) {
      setKnowWayToDelete(id)
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = () => {
    if (knowWayToDelete) {
      dispatch(remove(knowWayToDelete))
      dispatch(
        fetchKnowWay(filters, meta?.per_page || 10, meta?.current_page || 1)
      )
      setOpenDeleteModal(false)
      setKnowWayToDelete(null)
    }
  }

  return (
    <>
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size="small"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(rows, getSorting(order, orderBy)).map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`

              return (
                <TableRow hover tabIndex={-1} key={row.id}>
                  <StyledTableCellBody padding="checkbox" />
                  <StyledTableCellBody>{row.name}</StyledTableCellBody>
                  <StyledTableCellBody>
                    <Box
                      className={[
                        classes.status,
                        row.status == 1 ? classes.statusAtivo : '',
                      ]}
                    >
                      {row.status_text}
                    </Box>
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {canUpdate('como-conheceu', permissionUser) && (
                      <IconButton
                        aria-label="edit"
                        component={Link}
                        to={`/knowWay/${row.id}/edit${location.search || ''}`}
                      >
                        <Icon path={mdiNoteEditOutline} size={1} />
                      </IconButton>
                    )}
                    {canDelete('como-conheceu', permissionUser) && (
                      <IconButton onClick={() => handleOpenDeleteModal(row.id)}>
                        <Icon path={mdiDelete} size={1} />
                      </IconButton>
                    )}
                  </StyledTableCellBody>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={meta?.total || 10}
        rowsPerPage={meta?.per_page}
        page={meta?.current_page - 1}
        labelRowsPerPage="Linhas por Página"
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        labelDisplayedRows={({ from, to, count }) =>
          `Mostrando linhas ${from}-${to} de ${count}`
        }
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onChangePage={onMovePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Como Conheceu"
        message="Deseja realmente excluir este registro?"
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}

export default withRouter(List)
